/**
 * Hot Selling Products Section JavaScript
 * Handles additional functionality for the hot selling products section
 */

class HotSellingProducts extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Add loading completed class after a short delay
    setTimeout(() => {
      this.classList.add('loaded');
    }, 100);

    // Handle badge hover effects
    this.handleBadgeEffects();
    
    // Handle responsive grid adjustments
    this.handleResponsiveGrid();
    
    // Initialize slider if present
    this.initializeSlider();
  }

  handleBadgeEffects() {
    const badges = this.querySelectorAll('.hot-selling-badge');
    
    badges.forEach(badge => {
      // Add entrance animation
      badge.style.animation = 'fadeInScale 0.6s ease-out forwards';
      
      // Add random delay for staggered effect
      const delay = Math.random() * 0.3;
      badge.style.animationDelay = `${delay}s`;
    });
  }

  handleResponsiveGrid() {
    const grid = this.querySelector('.product-grid');
    if (!grid) return;

    // Add responsive classes based on settings
    const updateGridClasses = () => {
      const screenWidth = window.innerWidth;
      
      if (screenWidth >= 1200) {
        grid.classList.add('grid-desktop-active');
      } else if (screenWidth >= 750) {
        grid.classList.add('grid-tablet-active');
      } else {
        grid.classList.add('grid-mobile-active');
      }
    };

    updateGridClasses();
    
    // Update on resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateGridClasses, 250);
    });
  }

  initializeSlider() {
    const swiperContainer = this.querySelector('[data-swiper-slider]');
    if (!swiperContainer) return;

    // Enhanced slider initialization
    const options = {
      slidesPerView: 'auto',
      spaceBetween: 20,
      loop: true,
      autoplay: false,
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 15
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 25
        }
      }
    };

    // Initialize Swiper if available
    if (typeof Swiper !== 'undefined') {
      new Swiper(swiperContainer, options);
    }
  }

  // Public method to refresh the section
  refresh() {
    this.init();
  }

  // Public method to update product count
  updateProductCount(newCount) {
    const grid = this.querySelector('.product-grid');
    if (grid) {
      grid.dataset.productCount = newCount;
      this.handleResponsiveGrid();
    }
  }
}

// Define the custom element
customElements.define('hot-selling-products', HotSellingProducts);

// CSS Animation definitions
const style = document.createElement('style');
style.textContent = `
  @keyframes fadeInScale {
    0% {
      opacity: 0;
      transform: scale(0.8) translateY(10px);
    }
    100% {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }

  .hot-selling-products:not(.loaded) .hot-selling-badge {
    opacity: 0;
  }

  .hot-selling-products.loaded .hot-selling-badge {
    animation: fadeInScale 0.6s ease-out forwards;
  }


`;

document.head.appendChild(style);

// Auto-refresh functionality for theme editor
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const hotSellingSection = event.target.querySelector('hot-selling-products');
    if (hotSellingSection) {
      hotSellingSection.refresh();
    }
  });
}
